import { render, staticRenderFns } from "./soilManage.vue?vue&type=template&id=5c99554a&scoped=true"
import script from "./soilManage.vue?vue&type=script&lang=js"
export * from "./soilManage.vue?vue&type=script&lang=js"
import style0 from "./soilManage.vue?vue&type=style&index=0&id=5c99554a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99554a",
  null
  
)

export default component.exports